import { nameInitials } from "@/lib/constants";

function Initials({ name, size, className, title }) {
  return (
    <span
      title={title}
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-white/10 font-bold leading-none text-white/70 ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.36)) }}
      data-testid={name ? `avatar-${name.toLowerCase().replace(/\s+/g, "-")}` : "avatar"}
    >
      {nameInitials(name)}
    </span>
  );
}

export const PRESENCE = {
  online: { color: "#00FF66", label: "online now" },
  away: { color: "#FFB020", label: "away" },
};

// Neutral grey avatar with the person's initials; optional green (online) or yellow (away) dot.
export function Avatar({ name, size = 28, className = "", title, status }) {
  const label = title ?? name;
  const p = PRESENCE[status];
  if (!p) return <Initials name={name} size={size} className={className} title={label} />;
  const dot = Math.max(7, Math.round(size * 0.32));
  return (
    <span className="relative inline-flex shrink-0" title={`${label} · ${p.label}`}>
      <Initials name={name} size={size} className={className} title={`${label} · ${p.label}`} />
      <span
        className="absolute -bottom-px -right-px rounded-full ring-2 ring-[#0A0A0A]"
        style={{ width: dot, height: dot, backgroundColor: p.color }}
        data-testid={`avatar-${status}-dot`}
      />
    </span>
  );
}

export default Avatar;
